
import { l, tryGetTokenOverride, selectLanguage } from "./localization.js";



export const tours = {


    
    name(locale) {

        const overrideTranslation = tryGetTokenOverride(locale, "name");

        if (overrideTranslation) {
            return overrideTranslation;
        }
        
        const language = selectLanguage(locale, ["en", "de"]);

        switch (language) {
            case "en": return "Tours";
            case "de": return "Rundgänge";
            default: return `[name: ${language} missing]`;
        }
    
    },
            

    
    description(locale) {

        const overrideTranslation = tryGetTokenOverride(locale, "description");

        if (overrideTranslation) {
            return overrideTranslation;
        }
        return "Follow a tour vitually guided by one of our curators.";
    },
            
};
